"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _formatISO = _interopRequireDefault(require("date-fns/formatISO"));
var _pushDataLayer = _interopRequireDefault(require("@lumirental/lumi-web-sdk/dist/utils/gtm/pushDataLayer"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * When reservation send request is tapped.
 * @param {string} screenName
 * @param {Date} pickupDate
 * @param {Date} dropoffDate
 * @param {String} route,
 * @param {String} busType,
 * @param {String} email,
 * @param {String} phone,
 * @param {String} note,
 * @param {number} diffInDays
 */
function umrahReservationSuccess(screenName, pickupDate, dropoffDate, route, busType, email, phone, note, diffInDays) {
  var formattedPickupDate = (0, _formatISO["default"])(pickupDate);
  var formattedDropoffDate = (0, _formatISO["default"])(dropoffDate);
  var soldDays = diffInDays;
  var eventData = {
    event: 'send_umrah_request',
    screen_name: screenName,
    pickup_date: formattedPickupDate,
    dropoff_date: formattedDropoffDate,
    route: route.toLowerCase(),
    busType: busType,
    email: email,
    phone: phone,
    note: note.toLowerCase(),
    short_term: diffInDays < 30,
    rental_days: soldDays
  };
  console.log('** gtm event send_umrah_request: ', eventData);
  (0, _pushDataLayer["default"])(eventData);
}
var _default = exports["default"] = umrahReservationSuccess;